export default "__VITE_ASSET__Bluj7HaT__"